import React from 'react';

function Article() {
  return (
    <div className="video-article">
      <h3>Mujeres Productivas</h3>
      <p>¿Tenés dudas sobre cómo conseguir financiación o aumentar tus ventas?<br />
      ¿Querés emprender y no te animás?<br /><br />
      Mirá y encontrá las respuestas que estás buscando para impulsar sus proyectos.</p>
      <div className="embed-container">
        <div className='embed-responsive embed-responsive-16by9 with-curves'>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/DoKC8D6c4zM?si=fAbOCKnXXeF2pyA-" title="Mujeres Productivas" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
      </div>
    </div>
  );
}

export default Article;